import getConfig from "next/config";

export const buildProfilePictureUrl = (imageId: number): string => {

    const {publicRuntimeConfig} = getConfig();

    return `${publicRuntimeConfig.backendURL}api/user-profile/image/${imageId}`;
}